import { useCallback } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../utils/logger';

export function useDraftSaving(key: string) {
  const saveDraft = useCallback(
    async (data: any) => {
      try {
        const draftData = {
          ...data,
          savedAt: new Date().toISOString(),
        };
        await AsyncStorage.setItem(key, JSON.stringify(draftData));
      } catch (error) {
        logger.error('Failed to save draft:', error);
      }
    },
    [key]
  );

  const loadDraft = useCallback(async () => {
    try {
      const saved = await AsyncStorage.getItem(key);
      if (saved) {
        const parsed = JSON.parse(saved);
        // Remove the savedAt timestamp before returning
        const { savedAt, ...draftData } = parsed;
        return draftData;
      }
    } catch (error) {
      logger.error('Failed to load draft:', error);
    }
    return null;
  }, [key]);

  const clearDraft = useCallback(async () => {
    try {
      await AsyncStorage.removeItem(key);
    } catch (error) {
      logger.error('Failed to clear draft:', error);
    }
  }, [key]);

  const hasDraft = useCallback(async () => {
    try {
      const saved = await AsyncStorage.getItem(key);
      return saved !== null;
    } catch (error) {
      return false;
    }
  }, [key]);

  return {
    saveDraft,
    loadDraft,
    clearDraft,
    hasDraft,
  };
}
